var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{ref:"component",attrs:{"id":"myChart2"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }